import { Component } from 'react';
import { Text } from '@belong/ui';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import GoogleMap from '../../components/GoogleMap/GoogleMap';
import styles from './AccountPropertyBannerCard.module.css';

const cx = classNames.bind(styles);

class AccountPropertyBannerCard extends Component {
  static propTypes = {
    imageUrl: PropTypes.string,
    coordinates: PropTypes.object.isRequired,
    chip: PropTypes.node,
  };

  static defaultProps = {
    imageUrl: '',
    chip: null,
  };

  render() {
    const { imageUrl, coordinates, chip } = this.props;

    return (
      <div className={cx('banner-card')}>
        {chip && (
          <div className="absolute left-sm top-sm z-10 rounded bg-blue px-xs py-2xs">
            <Text
              as="span"
              className="text-white"
              fontWeight="semibold"
              variant="p1"
            >
              {chip}
            </Text>
          </div>
        )}
        <div className={cx('banner-images')}>
          {imageUrl && (
            <div
              className={cx('image')}
              style={{ backgroundImage: `url('${imageUrl}')` }}
            />
          )}
          {coordinates?.latitude && coordinates?.longitude && (
            <div className={cx('image')}>
              <GoogleMap
                streetView={false}
                lat={parseFloat(coordinates.latitude)}
                lng={parseFloat(coordinates.longitude)}
                zoom={13}
                controls={false}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default AccountPropertyBannerCard;
